import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";
import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";

/**
 * 物件概要書の金額取得APIへのリクエストボディ
 */
export interface IPropertySummaryAmountAPIRequest {
  address: string;
  landPrefectureName: string;
  landLocationFull: string;
  landChiban: string;
  hasLandReuse: boolean;
  landReuseDetailId: number | null;
  landReuseGetNewPicture: boolean;
  buildingPrefectureName: string;
  buildingLocationFull: string;
  buildingPrimaryKaokuNumber: string;
  hasBuildingReuse: boolean;
  buildingReuseDetailId: number | null;
  buildingReuseGetNewPicture: boolean;
  pastDays: number | null;
}

export interface IPropertySummaryAmountAPIResponse {
  propertySummaryCount: number;
  propertySummaryPrice: number;
  allMattersAnalyzeCount: number;
  allMattersAnalyzePrice: number;
  allMattersCount: number;
  allMattersPrice: number;
}

const url = "/property-summary/amount";

/**
 * 物件概要書の作成にかかる金額を取得するためのSWR Mutationを返します。
 * @param apiClient - HTTPリクエストを行うためのAxiosのインスタンス
 * @returns データ更新関数を含むSWR Mutationオブジェクト
 */
export const GetPropertySummaryAmount = (
  apiClient: AxiosInstance
): SWRMutationResponse<
  IPropertySummaryAmountAPIResponse | null,
  never,
  string,
  IPropertySummaryAmountAPIRequest
> => {
  const fetcher = async (
    url: string,
    { arg }: { arg: IPropertySummaryAmountAPIRequest }
  ): Promise<IPropertySummaryAmountAPIResponse | null> => {
    try {
      const response = await apiClient.get<IPropertySummaryAmountAPIResponse>(
        url,
        { params: arg }
      );
      return response.data;
    } catch (error) {
      if (isAxiosError(error)) {
        if (
          (error.response?.status ?? HttpStatusCode.InternalServerError) >=
          HttpStatusCode.InternalServerError
        ) {
          SendToTrackingService(error);
        }
      }
    }
    return null;
  };

  return useSWRMutation(url, fetcher, {
    revalidate: false,
  });
};
